import React, { useEffect, useState } from "react";
import CustomModal from "../common/CustomModal";
import api from "../../api/config";
import { toast } from "react-toastify";
import { connectEmail } from "../../validators/user/connectEmail";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { EMAIL_REGEX } from "../../constants/common";
// import PropertyDetail from "../../pages/user/PropertyDetail";

const ConnectModal = ({ handleClose, show,propertyName, propertyAddress }) => {
  const [form, setForm] = useState({
    companyName: "",
    name: "",
    phoneNo: "",
    email: "",
    message: `
    // Property URL : ${window.location.href} \n 
    // I want to know about this property `,
    listingUrl: window.location.href
  });
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    phoneNo: "",
    message: "",
  });

  useEffect(() => {
    if (isSubmitting) {
      validateForm();
    }
  }, [form]);

  // useEffect(() => {
  //   const urlParts = window.location.href.split('/');
  //   const propertyId = urlParts[urlParts.length - 1]; // Assuming ID is the last part
   
  //   setForm((prevForm) => ({
  //     ...prevForm,
  //     message: `
  //     Property Name: ${propertyName} \n
  //     Property Address: ${propertyAddress}
  //     I want to know about this property`,
  //   }));
  // }, []);

  useEffect(() => {
    setForm((prevForm) => ({
      ...prevForm,
      message: `Property Name: ${propertyName} \nProperty Address: ${propertyAddress}\nI want to know about this property`,
    }));
  }, [propertyName, propertyAddress]);
  

  const validateForm = () => {
    const newErrors = {
      name: connectEmail(form?.name?.trim(), "name"),
      phoneNo: connectEmail(form?.phoneNo?.trim(), "phoneNo"),
      email: connectEmail(form?.email?.trim(), "email"),
      message: connectEmail(form?.message?.trim(), "message"),
    };

    setErrors(newErrors);

    return Object.values(newErrors).every((error) => error === "");
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleChangeEmail = (e) => {
    setIsValid(EMAIL_REGEX.test(e.target.value));
    setForm({ ...form, email: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setIsSubmitting(true);
    const isFormValid = validateForm();
    if (isFormValid && isValid) {
      setIsSubmitting(false);
      try {
        const mobileRegex = /^[0-9]{8,15}$/;
        if (!mobileRegex.test(form.phoneNo)) {
          toast.error("Invalid mobile number");
          return;
        }
        const response = await api.post("/contact-us", form);
        if (response.status === 200) {
          toast.success("Submitted Successfully");
          handleClose();
          setForm({ ...form, name: "", email: "", phoneNo: "", message: `I want to know about this property: ${window.location.href}` });
        }
      } catch (error) {
        toast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    }
    setLoading(false);
    setIsSubmitting(false);
  };

  return (
    <CustomModal
      handleClose={handleClose}
      show={show}
      handleSubmit={handleSubmit}
      loading={loading}
      submitTitle="Send Mail"
      isIcon={true}
      icon={faEnvelope}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            id="name"
            name="name"
            value={form.name}
            onChange={(e) => handleChange(e)}
            className="concern-input"
            placeholder="Full Name*"
          />
          {errors.name && <div className="text-danger">{errors.name}</div>}
        </div>
        <div className="form-group">
          <input
            id="email"
            name="email"
            value={form.email}
            placeholder="Email*"
            onChange={handleChangeEmail}
            className="concern-input"
          />
          {!isValid && <div className="text-danger">Please enter a valid email address</div>}
          {errors.email && <div className="text-danger">{errors.email}</div>}
        </div>
        <div className="form-group">
          <input
            id="phoneNo"
            name="phoneNo"
            type="number"
            value={form.phoneNo}
            onChange={(e) => handleChange(e)}
            className="concern-input"
            placeholder="Mobile Number*"
          />
          {errors.phoneNo && (
            <div className="text-danger">{errors.phoneNo}</div>
          )}
        </div>
        <div className="form-group">
          <textarea
            id="message"
            name="message"
            value={form.message}
            onChange={(e) => handleChange(e)}
            placeholder="Draft Your Message"
            className="concern-input"
            rows={6}
          />
          {errors.message && (
            <div className="text-danger">{errors.message}</div>
          )}
        </div>
      </form>
    </CustomModal>
  );
};

export default ConnectModal;
